export enum RequisitesVerificationStatus {
  Active = 'active',
  Disabled = 'disabled',
  Success = 'success',
  Expired = 'expired',
}
